import axios from "axios";
import params from "../configs/params";

// Authentication uses the JWT Authorization header below. Sending browser
// cookies would require credentialed CORS and conflicts with the backend's
// wildcard development origin policy.
const brazeApi = axios.create({ baseURL: params.brazeUrl, withCredentials: false });
brazeApi.defaults.headers.common["Content-Type"] = "application/json";
brazeApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";
brazeApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

brazeApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        const response = await axios.post(`${params.apiUrl}auth/token/refresh/`, { token: refreshToken });
        const accessToken = response.data.accessToken;
        localStorage.setItem("accessToken", accessToken);
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return brazeApi(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default brazeApi;
